module.exports = __webpack_public_path__ + "static/media/place-accent.9b450685.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/place-accent.svg
// module id = 691
// module chunks = 0